var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('question-number',{staticStyle:{"margin-bottom":"15px"}}),_vm._v(" "),_c('action-buttons',{staticStyle:{"margin-bottom":"15px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c7aa189","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/teke-order-review/pages/TekeOrderReviewSidebar.vue
// module id = 5596
// module chunks = 34